module.exports = __webpack_public_path__ + "static/ventaja_competitiva-08e620d27585157571437b21e4d1602a.png";